import {
	Component,
	EventEmitter,
	Input,
	Output,
	OnChanges,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import LogRocket from 'logrocket';
import { TeranetService } from '@services/teranet/teranet.service';
import { MatterLRO } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { openCloseWithState } from '@core/animations/animations';
import { SnackbarService } from '@services/ui/snackbar.service';
import { UserProfileDispatch } from '@state/user-profile/dispatch';
import { TestHooks } from './search-by-pin.hooks';
import { firstValueFrom } from 'rxjs';
import { PinsResult } from '@models/teranet';

@Component({
	selector: 'app-teranet-search-by-pin',
	templateUrl: './search-by-pin.component.html',
	animations: [openCloseWithState()],
	standalone: false,
})
export class SearchByPinComponent implements OnChanges {
	testHooks = TestHooks;
	public pin: string;
	public pins: PinsResult;
	public searchingPins: boolean;
	public error: string;
	public submitted = false;
	public showSearchSection = true;

	public ICON = ICON;

	@Input() isOverview = false;
	@Input() showSearch = true;
	@Output() searchCompletedEvent = new EventEmitter<boolean>();

	@SelectSnapshot(SelectedMatter.LRO) lro: MatterLRO;
	@SelectSnapshot(SelectedMatter.id) saleId: string;

	constructor(
		private teranetService: TeranetService,
		private snackbar: SnackbarService,
		private userProfileDispatch: UserProfileDispatch,
	) {}

	ngOnChanges() {
		this.showSearchSection = this.showSearch;
	}

	async searchByPin(form: NgForm) {
		this.error = null;
		this.submitted = true;

		if (form.valid) {
			this.searchingPins = true;
			try {
				this.pins = await firstValueFrom(
					this.teranetService.searchByPin({
						lro: this.lro.selected.id,
						pin: this.pin.trim(),
					}),
				);
				this.searchCompleted(true);
			} catch (err) {
				LogRocket.log('Error searching pins', err);
				let friendlyError: string;
				if (!this.lro.selected?.id) {
					this.snackbar.openSnackBar({
						text: 'Error searching pins - Please Select an LRO',
						type: 'error',
					});
					friendlyError = 'Error searching pins - Please Select an LRO';
				} else
					friendlyError = this.teranetService.HandleError(
						'Error searching pins',
						err,
					);
				this.error = friendlyError;
				this.searchCompleted(false);
			} finally {
				this.searchingPins = false;
			}
		}
	}

	searchCompleted(value: boolean) {
		this.searchCompletedEvent.emit(value);
	}
}
